import { Injectable } from '@angular/core';
import { LoadingService } from '@core/services/loading.service';
import { PolicyService } from '@core/services/policy.service';
import { PolicyActions } from '@core/store/actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';

@Injectable()
export class PolicyEffects {
  constructor(
    private actions$: Actions,
    private policyService: PolicyService,
    private loadingService: LoadingService
  ) {}

  retrievePolicy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PolicyActions.retrievePolicy),
      switchMap((action) => {
        this.loadingService.beginLoading(
          'retrieve-policy',
          'Getting client information...'
        );

        return this.policyService
          .retrievePolicy(action.policyNumber, action.productType)
          .pipe(
            switchMap((response) => {
              let nextAction = null;
              const validProductTypes = [
                'PersonalAuto',
                'Homeowner',
                'Tenant',
                'Condominium',
                'PersonalUmbrella',
                'MSA',
                'Boat',
                'RV',
                'DwellingFire',
              ] as const;

              if (validProductTypes.includes(action.productType as any)) {
                nextAction = PolicyActions.retrievePolicySuccess({
                  payload: {
                    productType:
                      action.productType as (typeof validProductTypes)[number],
                    response,
                  },
                });
              } else {
                nextAction = PolicyActions.retrievePolicyFail({
                  error: `Unsupported productType: ${action.productType}`,
                });
              }
              this.loadingService.endLoading('retrieve-policy');
              return of(nextAction);
            }),
            catchError((error) => {
              this.loadingService.endLoading('retrieve-policy');
              return of(
                PolicyActions.retrievePolicyFail({
                  error: JSON.stringify(error.error),
                })
              );
            })
          );
      })
    )
  );
}
